export default __webpack_public_path__ + "static/media/American-express.a5c254b9.svg";